import { BulletList, Bullet } from 'components/BulletList';
import Box from 'components/Containers/Box';
import CenterAlignBox from 'components/Containers/CenterAlignBox';
import ColumnBox from 'components/Containers/ColumnBox';
import { Row } from 'components/Containers/Row/Row';
import RowBox from 'components/Containers/RowBox';
import SpreadBox from 'components/Containers/SpreadBox';
import OText from 'components/CText/OText';
import DisclaimerPortal from 'components/Disclaimer/DisclaimerPortal';
import { Button } from 'components/form/Button';
import { SmallModal } from 'components/Modals/SmallModal';
import PIcon from 'components/personalization/PIcon';
import AtomicSDKWrapper from 'pages/Cash/pages/DirectDepositInformation/components/AtomicSDKWrapper';
import React from 'react';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import Label from 'components/form/Label/Label';

const DirectDepositAutomaticView = props => {
  return (
    <>
      {props.seenPixel}
      <SectionContainer datatestid="direct-deposit-automatic-module">
        <Row>
          <SpreadBox>
            <ColumnBox widthClassName="format48 m-format100">
              <CenterAlignBox className="d-hide padB24">
                <PIcon icon={props.hero} />
              </CenterAlignBox>
              <Label type="H3 mH5 bold" className="padB16">
                <OText text={props.title} />
              </Label>

              <Label type="Body-1" className="padB24 m-padB20">
                <OText text={props.content} />
              </Label>

              <BulletList paddingLeftClass="padL0" className="margB32">
                {props.bullets?.map((b, x) => (
                  <Bullet
                    key={x}
                    textClass="padL8 padT4 Body-1"
                    bulletCharacter={
                      <Label className="text-24">{b.icon}</Label>
                    }
                  >
                    {b.text}
                  </Bullet>
                ))}
              </BulletList>
              {props.preCTAText && (
                <Label
                  type="caption"
                  className="padB20"
                  onClick={props.onClickTermsOfUse}
                >
                  <OText text={props.preCTAText} />
                </Label>
              )}
              <Box className="format100 padB16 m-padB12">
                <Button
                  mrphType="primary"
                  datatestid="click-switch-direct-deposit"
                  onClick={props.onClickSetupDirectDeposit}
                  className="padLR36"
                >
                  {props.ctaText}
                </Button>
              </Box>
              <Label className="caption">
                <OText text={props.postCTAText} />
              </Label>
            </ColumnBox>
            <ColumnBox
              widthClassName="format50"
              className=" t-hide"
              alignItemsEnd
            >
              <PIcon icon={props.hero} />
            </ColumnBox>
          </SpreadBox>
        </Row>
        <DisclaimerPortal name="DD_auto">
          <OText text={props.disclaimers} />
        </DisclaimerPortal>
      </SectionContainer>
      <SmallModal
        footer={
          <RowBox className="format100" justifyEnd noWrap={false}>
            <Button
              className="m-format100"
              mrphType="link"
              onClick={props.onClickCancelInfoModal}
            >
              Cancel
            </Button>
            <Button
              className="m-format100"
              mrphType="primary"
              onClick={props.onClickUpdateDirectDeposit}
            >
              Update
            </Button>
          </RowBox>
        }
        onCancel={props.onClickCancelInfoModal}
        visible={props.showUpdateDirectDepositInfoModal}
      >
        <Label type="H4 mH4 bold" className="padB16">
          Update Your Direct Deposit Information
        </Label>
        <Label type="Body-1" className="padB16">
          Need to update an existing direct deposit? Simply submit a new
          request, and we’ll take care of the rest for you.
        </Label>
      </SmallModal>
      <AtomicSDKWrapper
        isVisible={props.showAtomicSdk}
        publicToken={props.publicToken}
        onAtomicClose={props.onAtomicClose}
        onAtomicFinish={props.onAtomicFinish}
        filterAtomicEvents={props.filterAtomicEvents}
      />
    </>
  );
};

export default DirectDepositAutomaticView;
